import { render, staticRenderFns } from "./purchaseVolume.vue?vue&type=template&id=96f072b6&"
import script from "./purchaseVolume.vue?vue&type=script&lang=js&"
export * from "./purchaseVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports